import {AxiosRequestConfig} from "axios";
import Bowser from "bowser";
import ipApiJson from "../config/ip-api-json";

export async function getUserInfo(verificationId: string, token: string | null): Promise<AxiosRequestConfig> {
    const browserInfo = Bowser.parse(window.navigator.userAgent)
    const ipAddress = await ipApiJson.get("https://api.ipify.org/?format=json")
    return token ? {
            headers: {
                'Browser-name': browserInfo.browser.name,
                'Browser-version': browserInfo.browser.version,
                'OS': browserInfo.os.name,
                'x-api-key': token,
                'vid': verificationId,
                ipAddress: ipAddress.data.ip
            }
        } :
        {
            headers: {
                'Browser-name': browserInfo.browser.name,
                'Browser-version': browserInfo.browser.version,
                'OS': browserInfo.os.name,
                'vid': verificationId,
                ipAddress: ipAddress.data.ip
            }
        }
}